/* eslint-disable import/prefer-default-export */
import { easyPost } from './utils';

//  配置
export const getWechatMPEvConfig = easyPost('wechatScan.bike.newGray');

export const wechatScanUrlMetric = easyPost('wechat.scan.url.metric');
